<template>
  <div class="col">
    <div v-if="header.visible" class="row">
      <div class="col-10 d-flex justify-content-start align-items-center">
        <i :class="header.iconClass" />
        <strong>{{ header.title }}</strong>
      </div>
      <div class="col-2 d-flex justify-content-end align-items-center">
        <action-button
          class="outline-dark-gray"
          :disabled="false"
          :i="allExpanded ? 'fal fa-compress-arrows-alt' : 'fal fa-expand-alt'"
          :text="allExpanded ? 'Colapsar Todo' : 'Expandir Todo'"
          @click="toggleExpandCollapse"
        />
      </div>
    </div>
    <custom-collapse id="question-sections-collapse">
      <custom-collapse-item
        v-for="(item, key) in sections"
        :id="`section-collapse-item-${key + 1}`"
        :key="`section-collapse-item-${key + 1}`"
        :ref="`section-collapse-item-${key + 1}`"
        :auto-expand-collapse-enabled="false"
        class="my-3 collapse-item section bg-gray"
        :class="{ 'rounded invalid': item.valid === false }"
        :expanded="item.expanded"
        expanded-icon="fas fa-chevron-circle-right color-gray-7"
        minimized-icon="fas fa-chevron-circle-down color-green"
        parent-id="question-sections-collapse"
        read-only-icon="fas fa-plus-circle color-gray-2"
        :title="item.name"
        @expandButtonClick="expand(item, key)"
      >
        <div v-if="item.id == 130">
          <locality-form
            v-model="item.location"
            :is-preview="isPreview"
            :is-read-only="true"
          />
        </div>
        <questions
          v-else
          has-divider
          :is-preview="isPreview"
          :is-read-only="isReadOnly"
          :value="item.questions"
        >
          <template #selected-answer-questions="{ questions }">
            <div class="px-4">
              <questions :is-read-only="isReadOnly" :value="questions" />
            </div>
          </template>
        </questions>
      </custom-collapse-item>
    </custom-collapse>
  </div>
</template>

<script>
import Questions from './Question.vue';

import alert from '@/mixins/alert.mixin';
import CustomCollapse from '@/components/common/CustomCollapse.vue';
import ActionButton from 'ActionButton';
import CustomCollapseItem from '@/components/common/CustomCollapseItem.vue';
import { getSections } from '@/modules/bidQuestionConfig/api.js';
import LocalityForm from '@/views/infra/questionConfig/subViews/detail/components/LocalityForm.vue';

export default {
  name: 'QuestionForm',
  components: {
    Questions,
    CustomCollapse,
    CustomCollapseItem,
    LocalityForm,
    ActionButton,
  },
  mixins: [alert],
  props: {
    id: {
      type: Number,
      default: () => null,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    isPreview: {
      type: Boolean,
      default: () => false,
    },
    header: {
      type: Object,
      default: () => ({
        visible: false,
        title: 'Cuestionario',
        iconClass: 'fas fa-file mr-3 my-2 text-orange',
      }),
    },
  },
  data() {
    return {
      sections: [],
    };
  },
  computed: {
    allExpanded() {
      return this.sections.every((x) => x.expanded);
    },
  },
  async mounted() {
    await this.getSections();
  },
  methods: {
    toggleExpandCollapse() {
      const expand = !this.allExpanded;
      this.sections.forEach((x) => {
        x.expanded = expand;
      });
    },
    expand(item, key) {
      this.sections
        .filter((x, i) => i !== key)
        .forEach((x) => (x.expanded = false));
      setTimeout(() => (item.expanded = !item.expanded), 100);
    },
    async getSections() {
      const { data } = await getSections(this.id).catch((e) =>
        this.ShowToast('', e?.response?.data?.message, 'error')
      );
      data.forEach((q) => {
        q.value = null;
        q.expanded = false;
      });
      this.sections = data;
    },
  },
};
</script>

<style scoped lang="scss">
.outline-dark-gray {
  color: #3f5b60;
  background-color: #ffffff;
  border-color: #3f5b60;
}

.collapse-item ::v-deep .card-header {
  padding: 0.75rem 1rem !important;
}

.collapse-item ::v-deep .tag-badge-pei {
  background: none;
}

.collapse-item.section ::v-deep .shadow2 {
  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  box-shadow: none !important;
  background-color: #f7f7f7;
}
.collapse-item.section ::v-deep .card-header {
  border-radius: 0.25rem !important;
  border-bottom: 2px solid #e6e6e6;
}
.collapse-item.section ::v-deep .card-header .title-number-box {
  background-color: #2db782;
}

.collapse-item.invalid.section {
  border: 1px solid #ff0018 !important;
}
.collapse-item.invalid.section ::v-deep .card-header .title-number-box {
  background-color: #ff5b5c !important;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.custom-reorganize-btn {
  background-color: #405c64;
}
</style>
